export const REDIRECTS = [
  { from: '/dak', to: '/krankenkasse/dak', httpCode: 301 },
  { from: '/viactiv', to: '/krankenkasse/viactiv', httpCode: 301 },
  { from: '/meine-krankenkasse', to: '/krankenkasse/meine-krankenkasse', httpCode: 301 }
];
